import React from 'react';
import { FadeIn } from './FadeIn';
export const HowItWorksSection = () => {
  const steps = [{
    number: '1',
    text: 'Descargas el bundle en PDF y accedes a las 7 recetas y checklist'
  }, {
    number: '2',
    text: 'Preparas el batido del día en 5 minutos'
  }, {
    number: '3',
    text: 'Complementas con el ejercicio exprés y sientes la diferencia'
  }];
  return <section className="py-20 bg-darker" data-id="element-134">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <FadeIn data-id="element-136">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-16 text-center text-white" data-id="element-137">
            ¿Cómo <span className="text-brand-green" data-id="element-138">Funciona?</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-139">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-gray-800 z-0" data-id="element-140"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 + index * 0.2} className="relative z-10" data-id="element-141">
              <div className="flex flex-col items-center text-center" data-id="element-142">
                <div className="w-20 h-20 rounded-full bg-dark border-4 border-brand-green flex items-center justify-center text-2xl font-bold text-brand-green mb-6 shadow-[0_0_15px_rgba(74,222,128,0.2)]" data-id="element-143">
                  {step.number}
                </div>
                <p className="text-lg text-gray-300 font-medium px-4" data-id="element-144">
                  {step.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};